import { useAuth } from "../context/AuthContext";
import { authAPI } from "../services/api/auth.api";
import { authClient } from "../Utils/Common";
import { clearGeneratedImageCache } from "../components/ImagePreview/utils/generatedImageCache";
import { clearAllChatSelections } from "../components/Chat/utils/chatSelectionsStorage";

// Single source of truth for the full logout flow (best-effort backend
// notify, local session cleanup, then real Okta signOut with token
// revocation). Originally lived only in Sidebar's handleLogout; pulled out
// here so EnvironmentNotice's "Cancel" button can trigger the exact same
// flow instead of drifting out of sync with a second copy.
export const useLogout = () => {
  const { user, logout } = useAuth();

  return async (): Promise<void> => {
    try {
      if (user) {
        try {
          await authAPI.logout(user.userId);
        } catch {
          /* ignore */
        }
      }
      localStorage.removeItem("chat_session_id");
      localStorage.removeItem("session_id");
      // Free any generated-image bytes held for this session before it ends.
      clearGeneratedImageCache();
      // Each chat's saved picks only last until logout.
      clearAllChatSelections();
      logout();

      await authClient.signOut({
        revokeAccessToken: true,
        revokeRefreshToken: true,
        postLogoutRedirectUri: window.location.origin,
      });
    } catch (e) {
      console.error("Okta signOut failed:", e);
      try {
        await authClient.tokenManager.clear();
      } catch {
        /* ignore */
      }
      window.location.assign("/");
    }
  };
};
